import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import SpriteComponent from '../../../Component/Render/Sprite';
import { PlaySound } from '../../Audio/AudioHelper';
import { AwaitIterators } from '../AnimationHelper';
import Game from '../../../Game';
import { AudioTrackType } from '../../Audio/AudioClip';
import AnimationFrame from '../../../Component/AnimationFrame';
import TextComponent from '../../../Component/Render/Text';

export interface ShowTurnipRewardParams {
    rewardObject: GameObject;
    shinyObject: AnimationFrame;
    objectToHide?: GameObject;
    isHighReward: boolean;
    revealingAll?: boolean;
}

export class ShowTurnipReward extends AnimationClip<ShowTurnipRewardParams> {
    public *execute(
        gameObject: GameObject,
        meta: ShowTurnipRewardParams
    ): IterableIterator<number> {
        const iterators = new Array<IterableIterator<number>>();
        if (meta.revealingAll) {
            iterators.push(
                this.startTween(
                    this.getTween(meta.objectToHide.container).to({ alpha: 0 }, 100)
                )
            );
        } else {
            PlaySound(meta.isHighReward ? 'reward-high' : 'reward-low');
        }

        const rewardAlphaComponent = (
            meta.rewardObject.getComponent(SpriteComponent) ||
            meta.rewardObject.getComponent(TextComponent)
        );
        iterators.push(
            this.startTween(
                this.getTween(rewardAlphaComponent).to(
                    { alpha: meta.revealingAll ? 0.4 : 1 },
                    meta.revealingAll ? 100 : 300
                )
            )
        );

        if (!meta.revealingAll) {
            iterators.push(
                (function*() {
                    const shinySprite = meta.shinyObject.spriteComponent;
                    const shinyAnimFrame = meta.shinyObject;
                    shinySprite.alpha = 1;
                    yield* shinyAnimFrame.playOneLoop(meta.revealingAll ? 300 : 600);
                    shinySprite.alpha = 0;
                })()
            );
        }

        yield* AwaitIterators(iterators);
    }
}
